import SwipeableWrapper from './swipeable-wrapper';
import './swipeable-wrapper.scss';

export default SwipeableWrapper;
